import data from './attrs/data'
import methods from './attrs/methods'
import props from './attrs/props'

export default {
    name: 'DeleteAccount',
    data,
    methods,
    props
}
